module.exports = __webpack_public_path__ + "static/media/insurecomp_mainlogo_var1.04c763a1.png";